<template>
  <main class="content container">
    <div class="content__top">
      <ul class="breadcrumbs">
        <li class="breadcrumbs__item">
          <a class="breadcrumbs__link" href="index.html">
            Каталог
          </a>
        </li>
        <li class="breadcrumbs__item">
          <a class="breadcrumbs__link" href="cart.html">
            Корзина
          </a>
        </li>
        <li class="breadcrumbs__item">
          <a class="breadcrumbs__link">
            Оформление заказа
          </a>
        </li>
      </ul>

      <h1 class="content__title">
        Корзина
      </h1>
      <span class="content__info">
        3 товара
      </span>
    </div>

    <section class="cart">
      <form class="cart__form form" action="#" method="POST" @submit.prevent="order">
        <div class="cart__field">
          <div class="cart__data">
              
        
            <BaseFormText title="ФИО" :error="formError.name" v-model="formData.name"
            placeholder="Введите ваше полное имя"></BaseFormText>
            <BaseFormText v-model="formData.address" title="Адрес доставки" :error="formError.address" 
            placeholder="Введите ваш адресс"></BaseFormText>
            <BaseFormText v-model="formData.phone" title="Телефон" :error="formError.phone" 
            placeholder="Введите ваш телефон"></BaseFormText> 
            <BaseFormText v-model="formData.email" title="Email" :error="formError.email" 
            placeholder="Введите ваш Email"></BaseFormText> 
           
      
          </div>
            <BaseFormTextArea title="Комментарии к заказу" :error="formError.comments" v-model="formData.comments"
            placeholder="Ваши пожелания"></BaseFormTextArea>
          

          <div class="cart__options">
            <h3 class="cart__title">Доставка</h3>
            <ul class="cart__options options">
              <li class="options__item">
                <label class="options__label">
                  <input class="options__radio sr-only" type="radio" name="delivery" value="0" checked="">
                  <span class="options__value">
                    Самовывоз <b>бесплатно</b>
                  </span>
                </label>
              </li>
              <li class="options__item">
                <label class="options__label">
                  <input class="options__radio sr-only" type="radio" name="delivery" value="500">
                  <span class="options__value">
                    Курьером <b>500 ₽</b>
                  </span>
                </label>
              </li>
            </ul>

            <h3 class="cart__title">Оплата</h3>
            <ul class="cart__options options">
              <li class="options__item">
                <label class="options__label">
                  <input class="options__radio sr-only" type="radio" name="pay" value="card">
                  <span class="options__value">
                    Картой при получении
                  </span>
                </label>
              </li>
              <li class="options__item">
                <label class="options__label">
                  <input class="options__radio sr-only" type="radio" name="pay" value="cash">
                  <span class="options__value">
                    Наличными при получении
                  </span>
                </label>
              </li>
            </ul>
          </div>
        </div>

        <div class="cart__block">
          <ul class="cart__orders">
            <li class="cart__order" v-for="item in this.arr" :key="item.id">
              <h3>{{item.product.title}}</h3>
              <b>{{item.quantity*item.price}} ₽</b>
              <span>Артикул: {{item.id}}</span>
            </li>
          </ul>
          
          <div class="cart__total">
            <p>Доставка: <b>500 ₽</b></p>
            <p>Итого: <b>{{this.allCount}}</b> товара на сумму <b>{{this.allSumma}} ₽</b></p>
            
          </div>

          <button class="cart__button button button--primery" type="submit" v-if="this.allCount>0">
            Оформить заказ
          </button>
          <p v-if="this.ordering==1">Подождите идет оформление заказа </p>
        </div>
        <div class="cart__error form__error-block" v-if="formErrorMessage">
          <h4>Заявка не отправлена!</h4>
          <p>
           {{formErrorMessage}}
          </p>
        </div>
      </form>
    </section>
  </main>

  </template>
  <script>
    import {mapActions} from "vuex"
     import BaseFormText from "@/components/BaseFormText"
     import BaseFormTextArea from "@/components/BaseFormTextArea"
     import axios from "axios" 
     import { API_BASE_URL } from '../config'
     export default{
         components:{BaseFormText,BaseFormTextArea},
         data(){
             return{
                 formData:{},
                 formError:{},
                 formErrorMessage:'',
                 arr:[],         
                 allCount:0,
                 allSumma:0,
                 ordering:0    

                 
             }
         },

        async created() {
          let response= await this.loadCart();
           
                
               this.arr = response.data.items.slice();            
                
                this.arr.map((el)=>{
                  this.allCount=this.allCount+el.quantity
                  this.allSumma=this.allSumma+(el.quantity*el.price)
                  
                  })   

             console.log(this.arr)
            
        },
        
         methods:{
         ...mapActions(['loadCart']),

           order(){
            this.ordering=1
            setTimeout(() =>  
            { 
            this.formErrorMessage=''
             this.formError={}
            axios 
            .post(API_BASE_URL+'/api/orders',{
                ...this.formData
            },{
              params:{
                userAccessKey:this.$store.state.userAccessKey
              }
            })
            .then(response=>{
                this.$store.commit('resetCart');
                this.$store.commit('updateOrderInfo',response.data);
                this.$router.push({name:'orderInfo',params:{id:response.data.id}})

            })
                .catch(error=>{
                    this.formError=error.response.data.error.request||{}
                    this.formErrorMessage=error.response.data.error.message;
              this.ordering=0
                })
            },2000)
           }
          
          
          
          
          
          }
       }
  

                       
                 
       
                 
  </script>
  